/* eslint-disable complexity */
/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import {makePriceLabelRound} from "../../../utils/helpers/make-price-label";
import Button from "../../shared/button";

const clamp = (v, min = 0, max = 1) => Math.min(Math.max(v, min), max);

const NUMBERS = {
    ZERO_POINT_ZERO_SEVEN: 0.07,
    ZERO_POINT_NINE_TWO: 0.92,
    ZERO_POINT_ONE_SEVEN: 0.17,
    ZERO_POINT_EIGHT_FIVE: 0.85
};

const CarPriceGuideCard = ({
    egc = 0,
    priceScale = {},
    handleCarPriceGuideCardModal,
    isModal = false,
    content = {}
}) => {
    const {priceMin = 0, priceMax = 0, priceLowerMid = 0, priceUpperMid = 0} = priceScale || {};
    const onClick = () => {
        handleCarPriceGuideCardModal();
    };
    const {kbbAskingPrice = 0, vehicleRetailPrice = 0} = content || {};
    const vehicleAskingPrice = vehicleRetailPrice || kbbAskingPrice || 0;
    const range = priceMax - priceMin || 1;
    const tooltipLocationPercentage = (egc - priceMin) / range;

    const isBelowMarket = egc < vehicleAskingPrice;
    const priceDifference = Math.abs(vehicleAskingPrice - egc);

    const TOOLTIP_MIN = isModal ? NUMBERS.ZERO_POINT_ZERO_SEVEN : NUMBERS.ZERO_POINT_ONE_SEVEN;
    const TOOLTIP_MAX = isModal ? NUMBERS.ZERO_POINT_NINE_TWO :  NUMBERS.ZERO_POINT_EIGHT_FIVE;
    const tooltipClampedPct = clamp(tooltipLocationPercentage, TOOLTIP_MIN, TOOLTIP_MAX) * NUMBER.HUNDRED;

    let arrowLeft = "50%";
    if (tooltipLocationPercentage <= 0) arrowLeft = "17%";
    else if (tooltipLocationPercentage >= 1) arrowLeft = "90%";

    const tooltipStyle = {
        left: `${tooltipClampedPct}%`,
        transform: "translateX(-50%)",
        ["--arrow-left"]: arrowLeft
    };

    const pointerStyle = {
        transform: "translateX(-50%)"
    };

    let label = "";
    if (egc < priceLowerMid) label = "is low";
    else if (egc > priceUpperMid) label = "is high";

    // decide number color based on meter segment (green/amber/red)
    let differenceClass = "styles.moderate";
    if (egc < priceLowerMid) differenceClass = "styles.cheaper";
    else if (egc > priceUpperMid) differenceClass = "styles.expensive";

    return (
        <div styleName={`styles.wrapper ${isModal ? "modalWrapper" : ""}`}>
            {!isModal && <p styleName={"styles.heading"}>Car price guide</p>}
            <div styleName={"styles.contentWrapper"}>

                <div styleName={"styles.slider-container"}>
                    <div styleName={"styles.tooltip"} style={tooltipStyle}>
                        {makePriceLabelRound(egc)} {label}
                        <div styleName={"styles.pointer"} style={pointerStyle}>
                            <div styleName={"styles.circle"} />
                        </div>
                    </div>

                    <div styleName={`styles.bar ${isModal ? "styles.barModal" : ""}`}>
                        <div styleName={"styles.low"} />
                        <div styleName={"styles.midWrapper"}>
                            <div styleName={`styles.mid ${isModal ? "styles.midModal" : ""}`} />
                            <div styleName={"styles.labels"}>
                                <span>{makePriceLabelRound(priceLowerMid)}</span>
                                <span>{makePriceLabelRound(priceUpperMid)}</span>
                            </div>
                        </div>
                        <div styleName={"styles.high"} />
                    </div>
                </div>
                <div styleName={"styles.detailWrapper"}>
                    <p styleName={"styles.detail"}>Cars24 rates this vehicle <span>{makePriceLabelRound(egc)}</span> as '{isBelowMarket ? "Below" : "Above"} Market Price' due to its listing at <span styleName={differenceClass}>{makePriceLabelRound(priceDifference)}</span> {isBelowMarket ? "cheaper" : "more"} than the market average
                    </p>

                    {isModal && (
                        <div styleName={"styles.infoSection"}>
                            <div styleName={"styles.infoBlock"}>
                                <h3 styleName={"styles.infoTitle"}>How we determine market price?</h3>
                                <p styleName={"styles.infoText"}>
                            Cars24 partners with Autograb to ascertain a fair price for a used car in Australia.
                                </p>
                            </div>
                            <div styleName={"styles.infoBlock"}>
                                <h3 styleName={"styles.infoTitle"}>What is Autograb?</h3>
                                <p styleName={"styles.infoText"}>
                            Autograb is a trusted automotive data platform that provides real-time market valuations and pricing insights. It aggregates live market data to offer accurate, up-to-date price estimations for used cars across Australia.
                                </p>
                            </div>
                        </div>
                    )}

                    {!isModal && <div styleName={"styles.buttonContainer"}>
                        <Button
                            variant={"secondary"}
                            text="How we determine market price?"
                            onClick={onClick}
                        />
                    </div>}
                </div>
            </div>
        </div>
    );
};

CarPriceGuideCard.propTypes = {
    egc: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    priceScale: PropTypes.object,
    handleCarPriceGuideCardModal: PropTypes.func,
    isModal: PropTypes.bool,
    content: PropTypes.object
};

export default CarPriceGuideCard;
